module.exports = __webpack_public_path__ + "img/Secondary-chevron-blue.a0b40303.svg";